import { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Admins from '../src/components/Admins/Admins';
import Analytics from '../src/components/Analytics/Analytics';
import Dashboard from '../src/components/Dashboard/Dashboard';
import Header from '../src/components/Header/Header';
import DailyReports from '../src/components/DailyReports/DailyReports';
import Sidebar from '../src/components/Sidebar/Sidebar';
import './AdminPanel.css';
import Mentor from './components/Mentors/Mentor';
import Expert from './components/Experts/Expert';
import Meetings from './components/Meetings/Meetings';
import Users from './components/Users/Users';
import PushEmail from './components/Push Email/PushEmail';
import Seminar from './components/Seminar/Seminar';
import Feedback from './components/Feedback/Feedback';
import SeminarBookings from './components/Seminar Booking/SeminarBooking';

function AdminPanel() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  return (
    <div className="grid-container">
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@700&family=Roboto:wght@400;700&family=Open+Sans:wght@400;700&family=Lato:wght@400;700&family=Montserrat:wght@400;700&family=Nunito:wght@400;700&family=Raleway:wght@400;700&family=Ubuntu:wght@400;700&family=Work+Sans:wght@400;700&family=Merriweather:wght@400;700&display=swap" rel="stylesheet"></link>
      <Header OpenSidebar={OpenSidebar} />
      <Sidebar openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar} />
      <div className="main-container">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="manage-career-coaches" element={<Mentor />} />
          <Route path="manage-professionals" element={<Expert />} />
          {/* <Route path="daily-reports" element={<DailyReports />} />
          <Route path="analytics" element={<Analytics />} /> */}
          <Route path="meetings" element={<Meetings />} />
          <Route path="users" element={<Users />} />
          <Route path="push-email" element={<PushEmail />} />
          <Route path="seminar" element={<Seminar />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="seminar-bookings" element={<SeminarBookings />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </div>
    </div>
  );
}

export default AdminPanel;
